var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.5,5H63C47,5,34,18,34,34v43.5H5v29h29v29H5v29h29v29H5v29h29V266c0,16,13,29,29,29h217.5 c8,0,14.5-6.5,14.5-14.5v-261C295,11.5,288.5,5,280.5,5z M164.5,48.5c23.9,0,43.5,19.6,43.5,43.5c0,23.9-19.6,43.5-43.5,43.5 c-23.9,0-43.5-19.6-43.5-43.5C121,68.1,140.6,48.5,164.5,48.5z M251.5,237h-174v-10.9c0-32.2,39.2-65.3,87-65.3 c47.8,0,87,33.1,87,65.3V237z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacto);
export default __webpack_public_path__ + "static/media/contacto.dd5dab8ed1d917968e7530f24e08ef6e.svg";
export { ForwardRef as ReactComponent };